import { useEffect, useState } from "react";

//ionic
import { IonButton, IonGrid, IonText } from "@ionic/react";

//css
import "./progress-component.css";

//recoil
import { useRecoilValue } from "recoil";
import { userInfoState } from "recoil/User";
import { useGetCertificates } from "hooks/examen/useGetCertificates";
import { CertificadoExamenModal } from "components/modal/certificado-examen/CertificadoExamenModal";
import type { ICertificateItem } from "services/interfaces/IExam";

type Certificate = ICertificateItem;

interface GroupedObject {
  [date: string]: Certificate[];
}

const groupCertificatesByDate = (certificates: Certificate[]) => {
  const groupedCertificates: { [date: string]: Certificate[] } = {};

  certificates.forEach((certificate) => {
    const examDate = new Date(certificate.examDate);
    const formattedDate = examDate.toISOString().split("T")[0];

    if (!groupedCertificates[formattedDate]) {
      groupedCertificates[formattedDate] = [];
    }

    groupedCertificates[formattedDate].push(certificate);
  });

  const sortedDates = Object.keys(groupedCertificates).sort((a, b) => {
    const timestampA = new Date(a).getTime();
    const timestampB = new Date(b).getTime();
    return timestampB - timestampA;
  });

  const sortedAndGroupedCertificates: { [date: string]: Certificate[] } = {};
  sortedDates.forEach((date) => {
    sortedAndGroupedCertificates[date] = groupedCertificates[date];
  });

  return sortedAndGroupedCertificates;
};

const formatExamResult = (result: string): string => {
  const num = parseFloat(result);
  if (Number.isNaN(num)) return result;
  return Number.isInteger(num) ? String(num) : num.toFixed(1);
};

export const CertificadosTab: React.FC = () => {
  const user = useRecoilValue(userInfoState);
  const { idUser } = user;
  const { certificates, handleGetCertificates } = useGetCertificates();
  const [selectedCertificate, setSelectedCertificate] =
    useState<Certificate | null>(null);
  useEffect(() => {
    handleGetCertificates(Number(idUser));
  }, [handleGetCertificates, idUser]);

  const groupedObject: GroupedObject =
    groupCertificatesByDate(certificates);

  const handleOpenCertificadoModal = (certificate: Certificate) => {
    setSelectedCertificate(certificate);
  };

  const handleCloseCertificadoModal = () => {
    setSelectedCertificate(null);
  };

  return (
    <>
      <IonGrid className="p-historial-container">
        <IonText className="p-historial-title">Certificados</IonText>
        {Object.entries(groupedObject).length !== 0 &&
          Object.entries(groupedObject).map(([date, sessions]) => {
            return (
              <>
                <div className="p-historial-div">
                  <IonText className="p-historial-day">{date}</IonText>
                </div>
                {sessions.map((element: Certificate) => {
                  return (
                    <div
                      key={`${element.examDate}-${element.moduleName}`}
                      className="flex"
                      style={{
                        alignItems: "center",
                        marginTop: "16px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleOpenCertificadoModal(element)}
                    >
                      <div
                        className="p-circle"
                        style={{ background: "#FFE1D4" }}
                      ></div>
                      <div
                        className="flex"
                        style={{ flexDirection: "column", width: "100%" }}
                      >
                        <IonText className="p-historial-exercise">
                          {element.moduleName}
                        </IonText>
                        <IonText className="p-historial-description">
                          {element.userFullName} - Resultado:{" "}
                          {formatExamResult(element.examResult)}
                        </IonText>
                      </div>
                      <IonButton
                        color="orange"
                        fill="solid"
                        size="small"
                        style={{
                          flexShrink: 0,
                          marginLeft: "12px",
                          textTransform: "none",
                          fontWeight: 600,
                          width: "200px",
                          height: "35px",
                          fontSize: "18px",
                          marginRight: "30px",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenCertificadoModal(element);
                        }}
                      >
                        Ver Certificado
                      </IonButton>
                    </div>
                  );
                })}
              </>
            );
          })}
      </IonGrid>
      {selectedCertificate && (
        <CertificadoExamenModal
          userName={selectedCertificate.userFullName}
          result={Number(selectedCertificate.examResult)}
          sessionName={selectedCertificate.moduleName}
          handleClose={handleCloseCertificadoModal}
          isOpen={true}
          idBasis={selectedCertificate.idBasis}
          idModule={selectedCertificate.idModule}
          examDate={selectedCertificate.examDate}
          hideProgressPrompt={true}
        />
      )}
    </>
  );
};
